import { call, put, takeEvery } from 'redux-saga/effects'
import * as userActions from '../ducks/userDucks'
import * as userAuthApi from '../../apis/userAuthApi'
import * as userApi from '../../apis/userApi'

interface FetchLoginSaga {
  type: string
  payload: { username: string; password: string }
}

interface FetchQuerySaga {
  type: string
  payload?: string
}

interface FetchIdSaga {
  type: string
  payload: string | number
}

function* fetchLogin({ payload: { username, password } }: FetchLoginSaga) {
  try {
    const res = yield call(userAuthApi.login, username, password)
    yield put(userActions.loginSuccess(res))
  } catch (error) {
    yield put(userActions.loginFail(error))
  }
}

function* fetchListUser({ payload: queryString }: FetchQuerySaga) {
  try {
    const res = yield call(userApi.getListUser, queryString)
    yield put(userActions.getListUserSuccess(res))
  } catch (error) {
    yield put(userActions.getListUserFail(error))
  }
}

function* fetchDetailUser({ payload: id }: FetchIdSaga) {
  try {
    const res = yield call(userApi.getDetailUser, id)
    yield put(userActions.getDetailUserSuccess(res))
  } catch (error) {
    yield put(userActions.getDetailUserFail(error))
  }
}

function* fetchListOptionUser({ payload: queryString }: FetchQuerySaga) {
  try {
    const res = yield call(userApi.getListOptionUser, queryString)
    yield put(userActions.getListOptionUserSuccess(res))
  } catch (error) {
    yield put(userActions.getListOptionUserFail(error))
  }
}

export default function* watchUser() {
  yield takeEvery(userActions.login.toString(), fetchLogin)
  yield takeEvery(userActions.getListUser.toString(), fetchListUser)
  yield takeEvery(userActions.getDetailUser.toString(), fetchDetailUser)
  yield takeEvery(userActions.getListOptionUser.toString(), fetchListOptionUser)
}
